import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismButton, PrismTooltip } from '@mylighthouse/prism-ember';

interface GeneralButtonsButtonExportSignature {
  Args: {
    disabledMessage?: string;
    exportAction?: () => void;
    isDisabled?: boolean;
  };
  Element: Element;
}

export default class GeneralButtonsButtonExport extends Component<GeneralButtonsButtonExportSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get disabledMessage() {
    return this.args.isDisabled && this.args.disabledMessage;
  }

  @action handleExport(): void {
    if (!this.args.isDisabled) {
      this.args.exportAction?.();
    }
  }

  <template>
    <PrismButton
      @buttonType="ghost"
      @icon="excel-export"
      @isDisabled={{@isDisabled}}
      @onClick={{this.handleExport}}
      data-event-id="export-button"
      ...attributes
    >
      {{#if this.disabledMessage}}
        <PrismTooltip @side="bottom" @text={{this.disabledMessage}} />
      {{/if}}
    </PrismButton>
  </template>
}
